import { useEffect, useState } from 'react';
import { TIMEPICKER } from '../constant/Constant';
import { saveTime2ViewTime } from '../util/TimeTableUtil';

import DatePicker from 'react-datepicker';
import setHours from 'date-fns/setHours';
import { format } from 'date-fns';
import setMinutes from 'date-fns/setMinutes';
import 'react-datepicker/dist/react-datepicker.css';

const DateTimePickerBox = ({ title, value, size, onChange, disabled = false }) => {
    return (
        <div
            className={
                'form-box ' +
                (size != undefined ? (size == 'small' ? ' w-sm' : size == 'medium' ? ' w-md' : ' w-lg') : '')
            }
        >
            <div className='input-box'>
                <label htmlFor={title}>{title}</label>
                <div className='input-group'>
                    <DatePicker
                        className='form-control ipt-cal'
                        // className='form-control ipt-date w-140'
                        disabled={disabled}
                        selected={value}
                        onChange={onChange}
                        // dropdownMode='select' // 'scroll' | 'select' | undefined;
                        showTimeSelect
                        timeIntervals={5}
                        // timeCaption='Time'
                        dateFormat='yyyy/MM/dd HH:mm' // 화면의 시간 포맷
                        timeFormat='HH:mm' // dropdown 시간 포맷
                        minTime={setHours(setMinutes(new Date(), 0), 8)} // hidden 하는 방법은 설정으로는 없는 듯 함.
                        maxTime={setHours(setMinutes(new Date(), 0), 21)}
                        // isClearable // 초기화 버튼
                        // calendarContainer={MyContainer} // 추가적인 스타일 처리 필요한 경우 (크기고정 등)
                        popperPlacement='top-start' // 화면 넘어갈때 위치를 정할 수 있음.
                    />
                </div>
            </div>
        </div>
    );
};

export default DateTimePickerBox;
